export default class StripePaymentGateway {
    // #region Vars
    _initialized = false;
    _api = {};
    _configuration = {};
    // #endregion
    // #region Properties
    get isInitialized() {
        return this._initialized;
    }
    get api() {
        return this._api;
    }
    get isTestMode() {
        return this._configuration?.isTestMode ?? false;
    }
    // #endregion
    // #region Boostrap
    async initialize(configuration) {
        // #region Init
        if (!this._initialized) {
            this._configuration = configuration;
            try {
                //Init
                await appHost.pageMeta.loadScript('https://js.stripe.com/v3/');
                //Stripe
                this._api = Stripe(configuration.apiKey);
            }
            catch (error) {
                utils.logError("Failed to initialize Stripe-Components", error);
            }
            this._initialized = true;
        }
        // #endregion
        return true;
    }
    // #endregion
    // #region Core
    async createElement(name, methodConfiguration) {
        //Elements
        let elements = this.api.elements();
        //Configuration
        let tConfig = methodConfiguration;
        //Merge
        if (this._configuration.elements && this._configuration.elements[name]) {
            tConfig = utils.mergeDeep({}, this._configuration, methodConfiguration);
        }
        return elements.create(name, tConfig);
    }
    async handle(command, args) {
        // #region Card
        if (command === 'stripe_handle_card') {
            //Handle
            let tResult1 = await this.api.handleCardAction(args.externalToken);
            //Result
            if (tResult1.error) {
                return {
                    isSucceeded: false,
                    errorCode: tResult1.error.code,
                    errorMessage: tResult1.error.message,
                };
            }
            //Succeeded
            else {
                return {
                    isSucceeded: true,
                    nextAction: 'confirm',
                    data: tResult1.result
                };
            }
        }
        // #endregion
        // #region Url
        else if (command === 'redirect_to_url') {
            //Url
            window.location.href = args.nextActionUrl;
            //Result
            return {
                isSucceeded: true
            };
        }
        // #endregion
        // #region Fallback
        else {
            return {
                isSucceeded: true
            };
        }
        // #endregion
    }
}
